<template>
    <div v-if="showAlert" class="billing-status">
        <template v-if="isTrialEnded">
            Your trial has ended.
            Update your billing details to continue.
            <div @click="toBillingPage" class="billing-btn">
                Add Credit Card
            </div>
        </template>
        <template v-else-if="isExpiredCard">
            Your credit card has expired.
            Update your billing details to continue.
            <div @click="editCard" class="billing-btn">
                Update Credit Card
            </div>
        </template>
        <template v-else-if="isFailedPayment">
            Failed to process payment.
            Update your billing details to continue.
            <div @click="toBillingPage" class="billing-btn">
                Update Credit Card
            </div>
        </template>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {SETTINGS_BILLING} from '../../../../views/settings/settings-tabs'

export default {
    name: 'BillingStatuses',
    computed: {
        ...mapGetters([
            'isDemoTeam'
        ]),

        ...mapGetters('billing', [
            'billingInfo',
            'isTrialEnded',
            'isExpiredCard',
            'isFailedPayment'
        ]),

        showAlert() {
            return (this.isTrialEnded || this.isExpiredCard || this.isFailedPayment) && !this.isDemoTeam
        },

        isBillingPage() {
            return this.$route.name === 'settings' && this.$route.params.page === SETTINGS_BILLING
        }
    },

    methods: {
        toBillingPage() {
            this.$router.push({name: 'settings', params: {page: SETTINGS_BILLING}})
        },

        editCard() {
            this.$modal.show('edit-billing-card')
        }
    }
}
</script>

<style lang="scss" scoped>
    .billing-status {
        background: $color-purple-light;
        color: white;
        padding: 8px 16px;
    }

    .billing-btn {
        background: white;
        color: $color-purple-light;
        border-radius: 3px;
        display: inline-block;
        padding: 4px 8px;
        margin-left: 8px;
        font-weight: 500;

        &:hover {
            cursor: pointer;
        }
    }
</style>
